var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.3164 585.367L-73.3672 420.684L420.684 -73.3672L585.367 91.3164L91.3164 585.367Z",
    fill: "#F1C40F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.614 826.822L14.5448 623.753L623.753 14.5447L826.822 217.614L217.614 826.822Z",
    fill: "#C0392B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-110.743 495.435L-312.802 293.376L293.376 -312.802L495.435 -110.743L-110.743 495.435Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCg);
export default __webpack_public_path__ + "static/media/CG.5b5b93ba410c6807bce7601275e8662e.svg";
export { ForwardRef as ReactComponent };